module.exports = __webpack_public_path__ + "img/accessTip.85fa2443.jpg";